(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["titan-stockists"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('titan-stockists')) {
    customElements.define('titan-stockists', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.countryNav = this.querySelector('.ts__countries');
        this.countryLinks = [...this.countryNav.querySelectorAll('[data-country]')].map(link => {
          if (link.tagName === 'BUTTON') return link;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = link.className;
          button.dataset.country = link.dataset.country;
          button.hidden = link.hidden;
          button.innerHTML = link.innerHTML;
          button.setAttribute('aria-pressed', 'false');
          link.replaceWith(button);
          return button;
        });
        this.countryNav.setAttribute('aria-label', 'Filter stockists by country');
        this.groups = [...this.querySelectorAll('[data-country-group]')];
        this.form = this.querySelector('.ts__filters');
        this.country = 'all';
        this.results = this.querySelector('[data-results]');
        this.form.hidden = false;
        const all = this.querySelector('.ts__all');
        if (all) all.hidden = false;
        this.updateRegions();
        this.countryLinks.forEach(button => button.addEventListener('click', () => {
          this.country = button.dataset.country;
          this.updateRegions();
          this.filter();
        }, options));
        this.form.addEventListener('submit', event => event.preventDefault(), options);
        this.form.addEventListener('input', () => this.filter(), options);
        this.form.addEventListener('change', () => this.filter(), options);
        this.form.addEventListener('reset', () => { queueMicrotask(() => this.reset()); }, options);
        this.querySelector('[data-reset]').addEventListener('click', () => { this.form.reset(); }, options);
        this.addEventListener('error', event => {
          if (event.target.matches('.ts__image')) event.target.hidden = true;
        }, { capture: true, signal: this.controller.signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.form.reset();
          queueMicrotask(() => {
            const card = event.target.closest('[data-card]') || event.target.querySelector('[data-card]');
            if (card) card.scrollIntoView({ block: 'center', behavior: 'instant' });
          });
        }, options);
        this.filter(true);
      }
      disconnectedCallback() { clearTimeout(this.announceTimer); this.controller?.abort(); this.controller = null; }
      normalise(value) { return value.toLocaleLowerCase('en-GB').normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ''); }
      announce(text, initial) {
        clearTimeout(this.announceTimer);
        if (initial) return;
        this.announceTimer = setTimeout(() => {
          if (this.results.textContent !== text) this.results.textContent = text;
        }, 400);
      }
      updateRegions() {
        const select = this.form.elements.region;
        const previous = select.value;
        select.replaceChildren(new Option('All regions', 'all'));
        const regions = [...new Set(this.cards.filter(card => this.country === 'all' || card.dataset.country === this.country).map(card => card.dataset.region))].sort((a,b) => a.localeCompare(b,'en-GB'));
        regions.forEach(region => select.add(new Option(region, region)));
        select.value = regions.includes(previous) ? previous : 'all';
      }
      reset() {
        this.country = 'all';
        this.form.elements.q.value = '';
        this.form.elements.category.value = 'all';
        this.form.elements.rum.value = 'all';
        this.updateRegions();
        this.form.elements.region.value = 'all';
        this.filter();
      }
      filter(initial = false) {
        const fields = this.form.elements;
        const query = this.normalise(fields.q.value.trim());
        const category = fields.category.value;
        let count = 0;
        this.cards.forEach(card => {
          const d = card.dataset;
          const categoryMatch = category === 'all' || d.category === category || (category === 'online' && d.online === 'true');
          const match = (this.country === 'all' || d.country === this.country) && (fields.region.value === 'all' || d.region === fields.region.value) && categoryMatch && (fields.rum.value === 'all' || d.rum === fields.rum.value || (d.rum === 'both' && ['spiced','orange'].includes(fields.rum.value))) && (!query || this.normalise(d.search).includes(query));
          card.hidden = !match;
          if (match) count++;
        });
        this.countryLinks.forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.country === this.country));
        });
        this.groups.forEach(group => {
          const selected = this.country === 'all' || this.country === group.dataset.countryGroup;
          const visible = [...group.querySelectorAll('[data-card]')].some(card => !card.hidden);
          group.querySelectorAll('[data-region-group]').forEach(region => { region.hidden = ![...region.querySelectorAll('[data-card]')].some(card => !card.hidden); });
          const noMatch = group.querySelector('[data-country-no-match]');
          if (noMatch) noMatch.hidden = visible;
          group.hidden = !selected || (!visible && this.country === 'all');
        });
        const countryText = this.country === 'all' ? 'the UK' : this.country;
        this.announce(`${count} ${count === 1 ? 'verified business' : 'verified businesses'} shown in ${countryText}`, initial);
        this.querySelector('[data-empty]').hidden = count !== 0 || this.groups.length === 0 || this.groups.some(group => !group.hidden);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
